import { everest } from '~/services/serviceInstances';
import { Workflow } from '~/types/Workflow';

export const getWorkflow = async ({ workflowId }: { workflowId: string }) => {
  const workflow = (await everest.get(`/workflows/${workflowId}`)) as any;
  return {
    ...workflow,
    isDraft: workflow.status === 'draft',
    isPublished: workflow.published,
    canPublish: workflow.publishable,
    lastModifiedBy: workflow.lastModifiedById,
  } as Workflow;
};
